import { cx } from '@linaria/core';
import { useCallback } from 'react';
import { useNotifier } from '@provider/notifier';
import { defaultModalOverrides } from './_hook.manager.style.js';
import { Toolbar } from './molecule.toolbar.js';
import { PostloadedModalContent } from './organism.content.js';
import { jsx } from 'react/jsx-runtime';

function usePostloadedModal() {
  const notifier = useNotifier();
  return useCallback(function triggerModal(content, options) {
    return triggerPostloadedModal(notifier, content, options);
  }, [notifier]);
}
let modalId = 0;
function triggerPostloadedModal(notifier, content, options) {
  const id = `postloaded-modal--${modalId++}`;
  return notifier.modal({
    className: cx(defaultModalOverrides, options instanceof Promise ? undefined : options?.className, (options instanceof Promise || !options?.disableToolbar) && "withToolbar"),
    content: /*#__PURE__*/jsx(PostloadedModalContent, {
      id: id,
      children: content
    }),
    contentOutsideScrollcontainer: /*#__PURE__*/jsx(Toolbar, {
      contentId: id,
      extraButtons: Promise.resolve(options).then(options => options?.buttons),
      disableToolbar: Promise.resolve(options).then(options => options?.disableToolbar ?? false),
      disableSpeechSynthesisButton: Promise.resolve(options).then(options => options?.disableSpeechSynthesisButton ?? false)
    }),
    closeButtonLabel: options instanceof Promise ? "Luk" : options?.closeButtonLabel,
    persistOnNavigation: options instanceof Promise ? undefined : options?.persistOnNavigation,
    theme: options instanceof Promise ? undefined : options?.theme,
    shareBackdrop: false,
    includeSpeechButton: false,
    shouldAutoFocusContent: options instanceof Promise ? undefined : options?.shouldAutoFocusContent
  });
}

export { triggerPostloadedModal, usePostloadedModal };
//# sourceMappingURL=_hook.manager.js.map
